import React, { useEffect } from 'react';
import AOS from "aos";
import "aos/dist/aos.css";
import CaseStudyCard from '../Components/CaseStudyCard';
import caseStudies  from '../data/CaseStudiesData/caseStudies';
import { HiMiniArrowUpRight } from "react-icons/hi2";
import { Link } from 'react-router-dom';

const ProjectShowcase = () => {

      useEffect(() => {
        AOS.init();
      }, []);

  return (
    <section className="bg-bgDefault text-white px-4 py-12 lg:py-24 lg:px-12">
      <div className="container xl:mx-auto xl:max-w-screen-xl   overflow-hidden">
        {/* Header */}
        <div className="flex justify-between items-center mb-10">
          <h2 className="font-dmsans font-bold text-[36px] leading-[44px] tracking-[-6%] lg:text-heading-2 " >
            Ideas We’ve Brought to <span className="text-[#00E599] font-crimsonpro italic font-normal lg:text-heading-2">Life</span>
          </h2>

          <Link to="/case-studies" className="hidden sm:flex items-center gap-x-1 font-medium text-[20px] leading-[32px] underline underline-offset-[4px] decoration-[0.5px] decoration-solid">
        {/* <a
            href="/case-studies"
            className="hidden sm:flex items-center gap-x-1 font-medium text-[20px] leading-[32px] underline underline-offset-[4px] decoration-[0.5px] decoration-solid"
          > */}
            View all
            <HiMiniArrowUpRight className="w-6 h-6" /> 
          {/* </a> */}
          </Link>
        </div>

        {/* Project Grid */}
        <div className="grid md:grid-cols-3 gap-8" data-aos="fade-zoom-up"
          data-aos-easing="ease-in-back"
          data-aos-delay="300"
          data-aos-offset="0">
           {caseStudies.slice(0, 3).map((project, index) => ( 
            <CaseStudyCard
              key={index}
              image={project.image}
              title={project.title}
              tags={project.tags}
              link={project.link}
              alt={project.alt}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectShowcase;
